import { c as _c } from "react/compiler-runtime";
import { useCouponDetail } from '@/api/skippay/coupon';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
function getCouponId(queryParam: string | string[] | undefined) {
  if (!queryParam) {
    return 0;
  }
  if (Array.isArray(queryParam)) {
    return Number(window.atob(queryParam[0]));
  }
  return Number(window.atob(queryParam));
}
export function useCoupon() {
  const $ = _c(13);
  const router = useRouter();
  let t0;
  if ($[0] !== router.query.coupon) {
    t0 = getCouponId(router.query.coupon);
    $[0] = router.query.coupon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const couponId = t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  if ($[2] !== couponId) {
    t1 = {
      id: couponId
    };
    $[2] = couponId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !!couponId;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      enabled: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data
  } = useCouponDetail(t1, t3);
  let t4;
  let t5;
  if ($[6] !== couponId || $[7] !== data) {
    t4 = () => {
      if (data && couponId) {
        setIsVisible(true);
      }
    };
    t5 = [data, couponId];
    $[6] = couponId;
    $[7] = data;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== data || $[11] !== isVisible) {
    t6 = {
      isVisible,
      coupon: data,
      setIsVisible
    };
    $[10] = data;
    $[11] = isVisible;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}